import React from "react";

const DashboardHeader = ({ children }) => (
  <div className="card-board overflow-hidden">
    <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
      <h1 className="font-display font-bold text-xl text-brand-cream tracking-tight">
        My Signups
      </h1>
      <p className="text-sm text-brand-mist mt-1">
        Your entries, payments, and cancellations.
      </p>
    </div>
    {children}
  </div>
);

export default DashboardHeader;
